// src/utils/gs1Parser.js

export function parseGS1(barcode) {
  // Supprime l'entête GS1 si le scanner l'a capturée (ex: ]d2)
  let raw = barcode.replace(/^\]d2/, ''); 
  
  let result = { 
    cip: "Introuvable", 
    peremption: "Introuvable", 
    lot: "Introuvable", 
    raw: barcode 
  };

  let index = 0;

  // Parcours du code de gauche à droite
  while (index < raw.length) {
    let ai = raw.substring(index, index + 2); // Identifiant (ex: 01, 17, 10...)

    if (ai === '01') {
      // 01 = GTIN (Taille fixe : 14 caractères)
      let gtin = raw.substring(index + 2, index + 16);
      result.cip = gtin.startsWith('0') ? gtin.substring(1) : gtin;
      index += 16;
    } 
    else if (ai === '17') {
      // 17 = Péremption (Taille fixe : 6 caractères AAMMJJ)
      let exp = raw.substring(index + 2, index + 8);
      if (exp.length === 6) {
        let annee = "20" + exp.substring(0, 2);
        let mois = exp.substring(2, 4);
        let jour = exp.substring(4, 6);
        // GS1 autorise "00" pour le jour si c'est la fin du mois
        if (jour === '00') jour = '01'; 
        result.peremption = `${jour}/${mois}/${annee}`;
      }
      index += 8;
    } 
    else if (ai === '10' || ai === '21') {
      // 10 = Lot, 21 = Numéro de série (Taille variable jusqu'au séparateur ASCII 29)
      index += 2;
      let value = '';
      // On lit jusqu'à la fin ou jusqu'au caractère séparateur caché (\x1D ou code ASCII 29)
      while (index < raw.length && raw.charCodeAt(index) !== 29) {
        value += raw[index];
        index++;
      }
      if (ai === '10') result.lot = value;
      // Si on s'est arrêté sur un séparateur, on saute par-dessus pour le bloc suivant
      if (index < raw.length && raw.charCodeAt(index) === 29) {
        index++;
      }
    } 
    else {
      // Identifiant inconnu (taille variable potentielle) : on avance jusqu'au prochain séparateur
      let foundSeparator = false;
      while (index < raw.length) {
        if (raw.charCodeAt(index) === 29) {
          index++; // On saute le séparateur
          foundSeparator = true;
          break;
        }
        index++;
      }
      // Si pas de séparateur, c'est qu'on est à la fin du code
      if (!foundSeparator) break;
    }
  }

  return result;
}